import React, { useState, useEffect } from "react";
import Header from "..//../layouts/Header";
import { useDispatch, useSelector } from "react-redux";
import { Image, Row, Col } from "react-bootstrap";
import { Prompt, useLocation, useHistory } from "react-router-dom";
import useNavigateAlertHook from "../../utils/hooks/useNavigateAlertHook";
import axios from "axios";
import AddIcon from "..//..//assets/icons/addicon.svg";
import Add from "..//..//assets/icons/Add Assignee.svg";
import DownArrow from "../../assets/icons/arrowdown.svg";
import Bin from "../../assets/icons/Bin2.svg";
import Pagination from "../../components/Pagination/Pagination";
import "../../assets/styles/local/Teams.css";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import { Menu, Dropdown } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { API_URL } from "../../redux/constants/type";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  FetchMembers,
  FetchTeamMemberByCompany,
  addTeam,
  DeleteTeam,
  FetchTeam,
  UpdateTeam,
  deleteTeamMember,
} from "../../redux/actions/action";

import soundFilePath from "../../assets/audios/floating-notification-tone.wav";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { ROLES } from "../../utils/helpers/userRole";

const Teams = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const roleAccess = window.localStorage.getItem("roleid");
  const [modal, showModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const companyid = window.localStorage.getItem("companyid");
  const teamid = window.localStorage.getItem("teamid");
  const [teamName, setTeamName] = useState("");
  const [teamLogo, setTeamLogo] = useState("");
  const [query, setQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [selctMemberid, setSelctMemberid] = useState("");
  const [typeInScreen, setTypeInScreen] = useState("");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Co-Workers-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const handleAddTeamClick = () => {
    setShowForm(true);
    showModal(false);
    setShowUpdatePopup(false);
    setTeamName("");
    setTeamLogo(null);
    setSelectedMembers([]);
  };

  const handleCancel = () => {
    showModal(false);
    history.push("/Teams");
    setShowForm(false);
    setShowUpdatePopup(false);
    setTeamName("");
    setTeamLogo(null);
    setSelectedMembers([]);
  };

  const cancelModal = () => {
    if (typeInScreen !== "") {
      showModal(true);
    } else {
      setShowForm(false);
      setShowUpdatePopup(false);
      // history.push("/Teams");
    }
    // showModal(true);
    // history.push("/Teams");
  };

  const [dropDownOpen, setDropDownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropDownOpen(!dropDownOpen);
  };

  const closeDropdown = () => {
    setDropDownOpen(false);
  };

  const [addMemberDropdown, setAddMemberDropdown] = useState(false);

  const handleAddMemberClick = () => {
    setAddMemberDropdown(!addMemberDropdown);
    setTypeInScreen("asc");
  };

  const handleDeleteMember = (index) => {
    const updatedMembers = [...selectedMembers];
    updatedMembers.splice(index, 1);
    setSelectedMembers(updatedMembers);
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      setTeamLogo(selectedFile);
      setUpdatedTeamLogo(selectedFile);
    }
  };

  const handleImageDelete = (e) => {
    e.preventDefault();
    setTeamLogo(null);
    setAddMemberDropdown(false);
    setUpdatedTeamLogo("");
  };

  const [myImgData, setMyImgData] = useState([]);
  const [isError, setIsError] = useState("");
  const [add_image, setAdd_image] = useState("");

  const handleFileUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    const formData = new FormData();
    formData.append("file", fileUploaded);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setMyImgData(response.data);
      setAdd_image(response.data[0]);
    } catch (error) {
      console.error(error);
      setIsError(error.message);
    }
  };

  const [selectedMembers, setSelectedMembers] = useState([]);
  const [memberid, setMemberId] = useState("");

  const toggleSelectedMember = (member) => {
    setSelectedMembers((prev) => [...prev, member]);
    // const isSelected = selectedMembers.some(
    //   (selected) => selected.userid === member.userid
    // );

    // if (isSelected) {
    //   const updatedMembers = selectedMembers.filter(
    //     (selected) => selected.userid !== member.userid
    //   );
    //   setSelectedMembers(updatedMembers);
    // } else {
    //   setSelectedMembers([...selectedMembers, member]);
    // }
    // // setMemberId(member.userid);

    // setSelectedMembers([...selectedMembers, member]);

    // setFilteredMembers(memberData);

    setSearchQuery("");
    setAddMemberDropdown(false);
  };

  //fetchMember

  const [memberData, setMemberData] = useState([]);

  const FetchMember = useSelector((state) => state.user.fetchMembers);
  useEffect(() => {
    dispatch(FetchMembers(companyid));
  }, []);

  useEffect(() => {
    if (FetchMember.status === true) {
      setMemberData(FetchMember.data);
    } else {
    }
  }, [FetchMember]);

  //fetch search member

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredMembers, setFilteredMembers] = useState([]);

  useEffect(() => {
    const filtered = memberData.filter(
      (item) =>
        item.firstname?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.lastname?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    setFilteredMembers(filtered);
  }, [searchQuery, memberData]);

  //create team
  const [isTeamNameValid, setIsTeamNameValid] = useState(true);

  let array = [];
  selectedMembers.map((item) => {
    array.push({ memberid: item.userid });
  });

  const handleCreateTeam = () => {
    if (teamName.trim() === "") {
      setIsTeamNameValid(false);
      return;
    }

    dispatch(addTeam(companyid, teamName, add_image, array));
    setShowForm(false);
    setAdd_image("");
    setTeamName("");
    setTimeout(() => {
      dispatch(FetchTeamMemberByCompany(companyid));
    }, 2000);
  };

  //update team popup

  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teamId, setTeamId] = useState("");
  const [updateTeamId, setUpdateTeamId] = useState("");
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [updatedTeamName, setUpdatedTeamName] = useState("");

  useEffect(() => {
    if (selectedTeam) {
      setUpdatedTeamName(selectedTeam.teamName);
    }
  }, [selectedTeam]);

  const [updatedTeamLogo, setUpdatedTeamLogo] = useState("");

  useEffect(() => {
    if (selectedTeam) {
      setUpdatedTeamLogo(selectedTeam.teamLogo);
    }
  }, [selectedTeam]);

  const handleTeamClick = (selectedTeam) => {
    setSelectedTeam(selectedTeam);
    setTeamId(selectedTeam.teamId);
    setShowUpdatePopup(true);
  };

  const handleUpdateTeam = () => {
    if (updatedTeamName.trim() === "") {
      setIsTeamNameValid(false);
      return;
    }

    let updatedMembersArray = [];
    selectedMembers.forEach((item) => {
      updatedMembersArray.push({ memberid: item.userid });
    });
    dispatch(
      UpdateTeam(teamId, updatedTeamLogo, updatedTeamName, updatedMembersArray),
    );
    setShowUpdatePopup(false);

    setTimeout(() => {
      dispatch(FetchTeamMemberByCompany(companyid));
    }, 2000);
  };

  const ascHandleUpdateTeam = () => {
    // const array = [];
    // for (let index = 0; index < updateTeamData.length; index++) {
    //   array.push({
    //     memberid: updateTeamData.memberid,
    //   });
    // }

    let array = [];
    updateTeamData.map((item) => {
      return array.push({ memberid: item.memberid });
    });
    // setUpdateTeamData(array);

    dispatch(
      UpdateTeam(
        updateTeamId,
        add_image ? add_image : updatedTeamLogo,
        updatedTeamName,
        array,
      ),
    );
    setShowUpdatePopup(false);
    setDirty(false);

    setTimeout(() => {
      dispatch(FetchTeamMemberByCompany(companyid));
    }, 2000);
  };

  //fetch team member by company

  const fetchTeamMembers = useSelector((state) => state.user.fetchTeamMembers);

  useEffect(() => {
    dispatch(FetchTeamMemberByCompany(companyid));
  }, []);

  useEffect(() => {
    if (fetchTeamMembers.status === true) {
      setTableData(fetchTeamMembers.data);
      setTotalPages(Math.ceil(fetchTeamMembers.data.length / perPage));
    } else {
    }
  }, [fetchTeamMembers, perPage]);

  //fetch team details

  const [teamData, setTeamData] = useState([]);
  const [updateTeamData, setUpdateTeamData] = useState([]);
  // let teamFirstName = teamData.teamName;
  // let teamLastName = teamData.teamName.split(" ")[1] || "";

  const fetchTeam = useSelector((state) => state.user.fetchTeam);

  useEffect(() => {
    if (fetchTeam.status === true) {
      setTeamData(fetchTeam.data);
      setUpdateTeamData(fetchTeam.data[0].members);
    } else {
    }
  }, [fetchTeam]);

  //update team

  const [updateData, setUpdateData] = useState([]);
  const updateTeam = useSelector((state) => state.user.updateTeam);

  useEffect(() => {
    if (updateTeam.status === true) {
      setUpdateData(updateTeam.data);
      setAdd_image("");
    } else {
    }
  }, [updateTeam]);

  // delete team

  const handleDeleteTeam = () => {
    dispatch(DeleteTeam(teamId));
    setModalShow(false);

    setTimeout(() => {
      dispatch(FetchTeamMemberByCompany(companyid));
    }, 2000);
  };

  // asc navigate alert start
  // const [isDirty, setDirty] = useState(false);

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     if (isDirty) return "Are you sure you want to discard changes?";
  //   };
  //   //Detecting browser closing below👇
  //   window.onbeforeunload = handleBeforeUnload;

  //   return () => {
  //     window.onbeforeunload = null;
  //   };
  // }, [isDirty]);

  // asc navigate alert end
  const [isDirty, setDirty] = useNavigateAlertHook();

  const items = [
    {
      key: "0",
      label: (
        <div onClick={() => history.push("/member-list")}>
          {/* Employees */}
          {t("Employees")}
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={() => history.push("/Schedule")}>
          {/* Schedule */}
          {t("Schedule")}
        </div>
      ),
    },
    {
      key: "2",
      // label: "Vacation Reports",
      label: t("Vacation Reports"),
    },
  ];

  return (
    <>
      {/* <Prompt when={isDirty} message="Are you sure want to discard changes?" /> */}

      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            className="flex-wrap gap-5 d-flex align-items-baseline"
            style={{ display: "flex", gap: "10%" }}
          >
            <div
              className="fw-bold "
              style={{
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Co-Worker */}
              {t("Co-Workers")}
            </div>

            {/* <div
              className={`fw-bold dropdown col-3 ${dropDownOpen ? "open" : ""}`}
              onClick={toggleDropdown}
            >
              <span
                onClick={() => {
                  history.push("/Teams");
                }}
              >
                Teams
              </span>
              <img
                src={DownArrow}
                className={`downarrow1 ${dropDownOpen ? "active" : ""}`}
                alt=""
              />
              {dropDownOpen && (
                <div
                  className="dropdown-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span
                    onClick={() => {
                      history.push("/member-list");
                    }}
                  >
                    Employees
                  </span>
                </div>
              )}
              {dropDownOpen && (
                <div
                  className="dropdown-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span
                    onClick={() => {
                      history.push("/Schedule");
                    }}
                  >
                    Schedule
                  </span>
                </div>
              )}
              {dropDownOpen && (
                <div className="overlay" onClick={closeDropdown} />
              )}
            </div> */}

            <Dropdown
              trigger={["click"]}
              menu={{ items }}
              open={dropDownOpen}
              onOpenChange={(e) => setDropDownOpen(e)}
            >
              <div
                className="fw-bold dropdown col-3 HideForTablet"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                }}
              >
                <span
                  className="fw-bold "
                  onClick={() => {
                    history.push("/Teams");
                  }}
                >
                  {/* Teams */}
                  {t("Teams")}
                </span>
                {dropDownOpen ? <UpOutlined /> : <DownOutlined />}
              </div>
            </Dropdown>
          </div>
        }
      />
      <div className="parent">
        <div className="main">
          {roleAccess !== ROLES.VIEWER && (
            <div className={"add-team-btn"} onClick={handleAddTeamClick}>
              <Image height={17} width={17} src={AddIcon} />
              <p
                className="add-member-text ms-3 mb-0"
                onClick={handleCreateTeam}
              >
                {/* Create Team */}
                {t("Create Team")}
              </p>
            </div>
          )}
          {showForm && (
            <div className="custom-form">
              <div>
                <div className="addPic">
                  <label htmlFor="teamLogoInput" className="upload-label">
                    {teamLogo ? (
                      <div className="uploaded-image-container">
                        <img
                          src={URL.createObjectURL(teamLogo)}
                          alt="Uploaded Team Logo"
                          className="uploaded-image"
                          width="91"
                          height="91"
                        />
                        <div className="upload-overlay">
                          <span
                            className="change-text"
                            onClick={() => {
                              handleImageChange();
                              setTypeInScreen("asc");
                            }}
                          >
                            Change
                          </span>
                          <img
                            src={Bin}
                            alt="Delete"
                            className="delete-icon"
                            onClick={(e) => {
                              handleImageDelete(e);
                              setTypeInScreen("asc");
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <svg
                        width="91"
                        height="91"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="45.5"
                          cy="45.5"
                          r="40"
                          fill="none"
                          stroke="black"
                          stroke-dasharray="5"
                          stroke-width="2"
                        />
                        <text
                          x="50%"
                          y="40%"
                          fontSize="12"
                          textAnchor="middle"
                          alignmentBaseline="middle"
                          fill="black"
                        >
                          +
                        </text>
                        <text
                          x="50%"
                          y="60%"
                          fontSize="12"
                          textAnchor="middle"
                          alignmentBaseline="middle"
                          fill="black"
                        >
                          {/* Add a photo */}
                          {t("Add A Photo")}
                        </text>
                      </svg>
                    )}
                    <input
                      type="file"
                      id="teamLogoInput"
                      accept="image/*"
                      onChange={(e) => {
                        handleFileUpload(e);
                        handleImageChange(e);
                        setTypeInScreen("asc");
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>

                <div className="teamName">
                  <input
                    className="name text-center"
                    type="text"
                    // placeholder="Team Name "
                    placeholder={t("Team Name")}
                    onChange={(e) => {
                      setTeamName(e.target.value);
                      setTypeInScreen("asc");
                      setDirty(true);
                    }}
                    value={teamName}
                  />
                  <span style={{ color: "red" }}>*</span>
                </div>
              </div>

              <div className="addAssignee">
                <p>
                  {/* Members */}
                  {t("Members")}
                  <span className="ps-1" style={{ color: "red" }}>
                    *
                  </span>
                </p>
                <Image
                  height={51.2}
                  width={51.2}
                  src={Add}
                  onClick={handleAddMemberClick}
                />
                {addMemberDropdown && (
                  <div className="member-drop">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      onClick={() => {
                        setAddMemberDropdown(false);
                      }}
                    ></div>

                    <div
                      className="member-search"
                      style={{ marginBottom: "10px" }}
                    >
                      <input
                        type="text"
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          margin: "0 0 0 0rem",
                          opacity: "0.5",
                          borderBottom: "1px solid #A5A5A5",
                          color: "#A5A5A5",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                        // placeholder="Search"
                        placeholder={t("Search")}
                        className="search-style select-client-div"
                      />
                    </div>
                    <div className="list-height">
                      {filteredMembers.map((filteredItem, filteredIndex) => {
                        const isSelected = selectedMembers.some(
                          (x) => x.userid === filteredItem.userid,
                        );
                        return (
                          <div
                            key={filteredIndex}
                            className="d-flex pt-1 pb-1 pointer"
                            onClick={() =>
                              !isSelected && toggleSelectedMember(filteredItem)
                            }
                          >
                            {filteredItem.imageurl ? (
                              <img
                                alt=""
                                className="member-pic"
                                src={filteredItem.imageurl}
                                height="24px"
                                width="24px"
                                style={{
                                  borderRadius: "50px",
                                  borderColor: "#00246A",
                                }}
                              />
                            ) : (
                              <div
                                className="member-pic"
                                style={{
                                  backgroundColor: "#95A7C6",
                                }}
                              >
                                <p id="member-pic-abv">
                                  {filteredItem?.firstname?.[0]}
                                  {filteredItem?.lastname?.[0]}
                                </p>
                              </div>
                            )}
                            <p
                              className={`margin-0 ps-2 pt-2 ${
                                isSelected ? "text-muted" : ""
                              }`}
                              style={{
                                textTransform: "capitalize",
                                fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                color: "black",
                              }}
                            >
                              {filteredItem.firstname}&nbsp;{" "}
                              {filteredItem.lastname}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div className="team-list">
                <table>
                  <tbody>
                    {selectedMembers.map((member, index) => (
                      <tr key={index}>
                        <td className="col-2 pb-3">
                          <div className="member-pic">
                            {member.imageurl ? (
                              <img src={member.imageurl} alt="" />
                            ) : (
                              <div style={{ color: "#FAFAFA" }}>
                                {member.firstname[0]}
                                {member.lastname[0]}
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="col-8 membername">
                          {member.firstname}&nbsp;{member.lastname}
                        </td>
                        <td className="col-2 bin">
                          <img
                            src={Bin}
                            className="ms-5"
                            alt=""
                            onClick={() => handleDeleteMember(index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div>
                <div class="buttons">
                  <button
                    type="button"
                    class="CancelBtn me-5 asc"
                    onClick={cancelModal}
                  >
                    {/* Cancel */}
                    {t("Cancel")}{" "}
                  </button>
                  <button
                    type="button"
                    class="CreateBtn"
                    onClick={handleCreateTeam}
                    disabled={teamName === "" || array.length === 0}
                  >
                    {/* Create */}
                    {t("Create")}
                  </button>
                </div>
              </div>
            </div>
          )}

          {showUpdatePopup && (
            <>
              {teamData.map((team, index) => {
                // let teamFirstName = team.teamName[0];
                // let teamLastName = team.teamName.split(" ")[1][0];

                return (
                  <div className="custom-form" key={index}>
                    <div>
                      <div className="addPic">
                        <label htmlFor="teamLogoInput" className="upload-label">
                          <div className="uploaded-image-container">
                            <input
                              type="file"
                              id="teamLogoInput"
                              accept="image/*"
                              onChange={(e) => {
                                handleFileUpload(e);
                                handleImageChange(e);
                                setTypeInScreen("asc");
                              }}
                              style={{ display: "none" }}
                            />
                            {updatedTeamLogo ? (
                              <img
                                src={add_image ? add_image : updatedTeamLogo}
                                // src={updatedTeamLogo}
                                alt="updating..."
                                className="uploaded-image"
                                width="91"
                                height="91"
                              />
                            ) : (
                              <div className="asc_abbr">
                                {/* <p className="mb-0">
                                  {teamLastName
                                    ? teamFirstName + " " + teamLastName
                                    : teamFirstName}
                                </p> */}
                                <div className="initials">
                                  {team.teamName
                                    .split(" ")
                                    .map((namePart, index) => (
                                      <span key={index}>{namePart[0]}</span>
                                    ))}
                                </div>
                              </div>
                            )}

                            <div className="upload-overlay">
                              <span
                                className="change-text"
                                onClick={() => handleImageChange()}
                              >
                                {/* Change */}
                                {t("Change")}
                              </span>
                              <img
                                src={Bin}
                                alt="Delete"
                                className="delete-icon"
                                onClick={(e) => handleImageDelete(e)}
                              />
                            </div>
                          </div>
                          <input
                            type="file"
                            id="teamLogoInput"
                            accept="image/*"
                            onChange={(e) => {
                              handleFileUpload(e);
                              handleImageChange(e);
                              setTypeInScreen("asc");
                            }}
                            style={{ display: "none" }}
                          />
                        </label>
                      </div>

                      <div className="teamName">
                        <input
                          className="name text-center"
                          type="text"
                          // placeholder= "team Name"
                          placeholder={t("Team Name")}
                          onChange={(e) => {
                            setUpdatedTeamName(e.target.value);
                            setTypeInScreen("asc");
                            setDirty(true);
                          }}
                          value={updatedTeamName}
                        />
                      </div>
                    </div>

                    <div className="addAssignee">
                      <p>
                        {/* Members */}
                        {t("Members")}
                      </p>
                      <Image
                        height={51.2}
                        width={51.2}
                        src={Add}
                        onClick={() => {
                          handleAddMemberClick();
                        }}
                      />
                      {addMemberDropdown && (
                        <div className="member-drop">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() => {
                              setAddMemberDropdown(false);
                            }}
                          ></div>

                          <div
                            className="member-search"
                            style={{ marginBottom: "10px" }}
                          >
                            <input
                              type="text"
                              onChange={(e) => setSearchQuery(e.target.value)}
                              style={{
                                margin: "0 0 0 0rem",
                                opacity: "0.5",
                                borderBottom: "1px solid #A5A5A5",
                                color: "#A5A5A5",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                              // placeholder="Search"
                              placeholder={
                                t("Search")
                              }
                              className="search-style select-client-div"
                            />
                          </div>
                          <div className="list-height">
                            {filteredMembers.map(
                              (filteredItem, filteredIndex) => {
                                let existItem = false;
                                // we filter updateTeamData bcz we compare with that...
                                if (
                                  updateTeamData.find(
                                    (item) =>
                                      item?.memberid === filteredItem.userid,
                                  )
                                ) {
                                  existItem = true;
                                }

                                return (
                                  <div
                                    style={{
                                      backgroundColor: existItem
                                        ? "#e4e4e4"
                                        : "",
                                      borderRadius: existItem ? "20px" : "",
                                    }}
                                    key={filteredIndex}
                                    className="d-flex pt-1 pb-1 mb-2 pointer"
                                    onClick={() => {
                                      toggleSelectedMember(filteredItem);
                                      // for existItem delete start
                                      let index2 = updateTeamData.findIndex(
                                        (item) =>
                                          item?.memberid ===
                                          filteredItem.userid,
                                      );

                                      if (index2 !== -1) {
                                        let data = [...updateTeamData];
                                        data.splice(index2, 1);
                                        setUpdateTeamData(data);
                                        return;
                                      }
                                      // for existItem delete end
                                      // start item pushing...
                                      let invoiceListArray = [
                                        ...updateTeamData,
                                      ];
                                      invoiceListArray.push({
                                        memberid: filteredItem.userid,
                                        memberdetails: [
                                          {
                                            image: filteredItem.imageurl,
                                            firstname: filteredItem.firstname,
                                            lastname: filteredItem.lastname,
                                          },
                                        ],
                                      });
                                      setUpdateTeamData(invoiceListArray);
                                    }}
                                  >
                                    {filteredItem.imageurl ? (
                                      <img
                                        className="member-pic"
                                        alt=""
                                        src={filteredItem.imageurl}
                                        height="24px"
                                        width="24px"
                                        style={{
                                          borderRadius: "50px",
                                          borderColor: "#00246A",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        className="member-pic"
                                        style={{
                                          backgroundColor: "#d2dce9",
                                        }}
                                      >
                                        <p
                                          className="mb-0"
                                          style={{
                                            fontSize: "14px",
                                            color: "#00246a",
                                          }}
                                        >
                                          {/* {filteredItem.firstname[0]} */}
                                          {/* {filteredItem.lastname[0]} */}
                                          {filteredItem.firstname
                                            ? filteredItem.firstname[0]
                                            : ""}
                                          {filteredItem.lastname
                                            ? filteredItem.lastname[0]
                                            : ""}
                                        </p>
                                      </div>
                                    )}
                                    <p
                                      className="margin-0 ps-2 pt-2"
                                      style={{
                                        textTransform: "capitalize",
                                        fontSize:
                                          "clamp(14px, 1.025vw, 0.833vw)",
                                        color: "black",
                                      }}
                                      onClick={() => {
                                        setAddMemberDropdown(false);
                                      }}
                                    >
                                      {filteredItem.firstname}&nbsp;{" "}
                                      {filteredItem.lastname}
                                    </p>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="team-list">
                      <table>
                        <tbody>
                          {/* {selectedMembers.map((member, index) => (
                            <tr key={index}>
                              <td className="col-2 pb-3">
                                <div className="member-pic">
                                  {member.imageurl ? (
                                    <img src={member.imageurl} alt="" />
                                  ) : (
                                    <div style={{ color: "#FAFAFA" }}>
                                      {member.firstname[0]}
                                      {member.lastname[0]}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="col-8 membername">
                                {member.firstname}&nbsp;{member.lastname}
                              </td>
                              <td className="col-2 bin">
                                <img
                                  src={Bin}
                                  className="ms-5"
                                  alt=""
                                  onClick={() => handleDeleteMember(index)}
                                />
                              </td>
                            </tr>
                          ))} */}

                          {updateTeamData.map((member, index) => (
                            <tr key={index}>
                              <td className="col-2 pb-3">
                                <div className="member-pic">
                                  {member.memberdetails[0]?.image ? (
                                    <img
                                      src={member.memberdetails[0]?.image}
                                      alt=""
                                    />
                                  ) : (
                                    <div style={{ color: "#FAFAFA" }}>
                                      {member.memberdetails[0]?.firstname[0]}
                                      {member.memberdetails[0]?.lastname &&
                                        member.memberdetails[0]?.lastname[0]}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="col-8 membername">
                                {member.memberdetails[0]?.firstname}&nbsp;
                                {member.memberdetails[0]?.lastname}
                              </td>
                              <td className="col-2 bin">
                                <img
                                  src={Bin}
                                  className="ms-5"
                                  alt=""
                                  // onClick={() => handleDeleteMember(memberid)}
                                  onClick={() => {
                                    const updatedMembers = [...updateTeamData];
                                    updatedMembers.splice(index, 1);
                                    setUpdateTeamData(updatedMembers);
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div>
                      <div class="buttons">
                        <button
                          type="button"
                          class="CancelBtn me-5"
                          onClick={cancelModal}
                        >
                          {/* Cancel */}
                          {t("Cancel")}{" "}
                        </button>
                        <button
                          type="button"
                          class="CreateBtn"
                          onClick={ascHandleUpdateTeam}
                        >
                          {/* Change */}
                          {t("Change")}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}

          <div>
            <Row>
              <div className="row teams">
                <table>
                  <thead>
                    <tr>
                      <th className="col-1 team-label"></th>
                      <th className="col-2 team-label">
                        {/* Team Name  */}
                        {t("Team Name")}
                      </th>
                      <th className="col-8 team-label">
                        {/* Members  */}
                        {t("Members")}
                      </th>
                      <th className="col-1 team-label">
                        {/* Actions  */}
                        {t("Actions")}
                      </th>
                    </tr>
                  </thead>
                </table>
                <div className="line"></div>
              </div>
            </Row>
            {tableData
              .slice(currentPage * perPage, (currentPage + 1) * perPage)

              .filter((team) => {
                const memberMatches = team.members.some((member) =>
                  `${member.memberdetails[0]?.firstname} ${member.memberdetails[0]?.lastname}`
                    .toLowerCase()
                    .includes(query.toLowerCase()),
                );

                const teamNameMatches = team.teamName
                  .toLowerCase()
                  .includes(query.toLowerCase());

                return memberMatches || teamNameMatches;
              })

              .map((team, index) => (
                <Row>
                  <div key={index} className="row teams-list">
                    <table>
                      <tbody>
                        <tr>
                          <td className="col-1 ps-3">
                            <div className="member-pic">
                              {team.teamLogo ? (
                                <img src={team.teamLogo} alt="" />
                              ) : (
                                <div className="initials">
                                  {team.teamName
                                    .split(" ")
                                    .map((namePart, index) => (
                                      <span key={index}>{namePart[0]}</span>
                                    ))}
                                </div>
                              )}
                            </div>
                          </td>
                          <td
                            // className="col-2 teamname"
                            className={
                              roleAccess === process.env.REACT_APP_IS_OWNER ||
                              roleAccess === process.env.REACT_APP_IS_MANAGER
                                ? "col-2 teamname"
                                : "pointerEvent col-2 teamname"
                            }
                            onClick={() => {
                              handleTeamClick(team);
                              dispatch(FetchTeam(team.teamid));
                              setUpdateTeamId(team.teamid);
                            }}
                          >
                            {team.teamName}
                          </td>
                          <td className="col-8">
                            <div className="team-container">
                              {team.members
                                .slice(0, 15)
                                .map((member, index) => {
                                  return (
                                    <div
                                      key={`member-${index}`}
                                      className="col-1 info"
                                    >
                                      <div className="team-pic">
                                        {member.memberdetails[0]?.image ? (
                                          <img
                                            alt=""
                                            src={member.memberdetails[0]?.image}
                                          />
                                        ) : (
                                          <div className="initial">
                                            <span>
                                              {
                                                member.memberdetails[0]
                                                  ?.firstname[0]
                                              }
                                              {
                                                member.memberdetails[0]
                                                  ?.lastname[0]
                                              }
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      <p
                                        // className="asc_longText"
                                        style={{
                                          margin: "0.2rem",
                                        }}
                                        title={`${member.memberdetails[0]?.firstname} 
                                        ${member.memberdetails[0]?.lastname}`}
                                      >
                                        <span
                                          className="d-block text-truncate"
                                          style={{ maxWidth: "100px" }}
                                        >
                                          {member?.memberdetails[0]?.firstname}
                                        </span>

                                        <span
                                          className="d-block text-truncate"
                                          style={{ maxWidth: "100px" }}
                                        >
                                          {member?.memberdetails[0]?.lastname}
                                        </span>
                                      </p>
                                    </div>
                                  );
                                })}
                              {team.members.length > 15 && (
                                <div className="col-1 info">
                                  <div
                                    className="team-pic"
                                    style={{ backgroundColor: "#00246A" }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        color: "#ffffff",
                                      }}
                                    >
                                      +{team.members.length - 15}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td
                            // className="col-1 bin"
                            className={
                              roleAccess === process.env.REACT_APP_IS_OWNER ||
                              roleAccess === process.env.REACT_APP_IS_MANAGER
                                ? "col-1 bin"
                                : "pointerEvent col-1 bin"
                            }
                          >
                            <img
                              src={Bin}
                              className="ms-3"
                              alt=""
                              onClick={() => {
                                setTeamId(team.teamid);
                                setModalShow(true);
                              }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="line"></div>
                  </div>
                </Row>
              ))}
          </div>
        </div>
      </div>
      {tableData.length > 0 && (
        <div className="align-text-bottom stock-pagination">
          <Pagination
            perPage={perPage}
            setPerPage={setPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      )}

      {modal && (
        <CancelWarningModal
          show={modal}
          onHide={() => showModal(false)}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      {modalShow && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteTeam}
          show={modalShow}
          onHide={() => setModalShow(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={"No"}
          yes={"Yes"}
        />
      )}
    </>
  );
};

export default Teams;
